import React, { useState } from "react";
import { getDataWithEndpoint } from "../../functions/request";
import { formatDateHourToBR, saveData } from "../../functions/functionsUtility";
import { Button, Input, Select } from "antd";
import { FaSave } from "react-icons/fa";
import { DescriptionsLayout } from "../../layout";

const estados = [
    { value: "BR", label: "Brasil" },
  { value: "BA", label: "Bahia" },
  { value: "CE", label: "Ceará" },
  { value: "ES", label: "Espírito Santo" },
  { value: "GO", label: "Goiás" },
  { value: "MT", label: "Mato Grosso" },
  { value: "MS", label: "Mato Grosso do Sul" },
  { value: "MG", label: "Minas Gerais" },
  { value: "PR", label: "Paraná" },
  { value: "RJ", label: "Rio de Janeiro" },
  { value: "RS", label: "Rio Grande do Sul" },
  { value: "SC", label: "Santa Catarina" },
  { value: "SP", label: "São Paulo" },
];

const cotacoesLabel = [
  { label: "Cotação Cepea", value: "lei_cot" },
];

export default function InterLeiteCepea() {
  const [cotacoesData, setCotacoesData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const aux = Object.entries(cotacoesData).map(([key, value]) => {
    if (key !== "lei_data" && key !== "lei_uf") {
      const cotLabel = cotacoesLabel.find((label) => label.value === key);
      return {
        label: cotLabel ? cotLabel.label : key,
        children: (
          <Input
            className="input-number"
            value={value}
            disabled={isLoading}
            onChange={(event) => {
              const inputValue = event.target.value;
              const formattedValue = inputValue;
              const newData = {
                ...cotacoesData,
                [key]: formattedValue,
              };
              setCotacoesData(newData);
            }}
          />
        ),
        span: 2,
      };
    }
    return null;
  });

  const items = [
    {
      label: "Estado",
      children: (
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          placeholder="Selecione um estado"
          filterOption={(input, option) =>
            (option?.label ?? "").includes(input)
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={estados}
          loading={isLoading}
          onChange={(value) => {
            setIsLoading(true);
            setCotacoesData([]);
            getDataWithEndpoint(
              "leite_cepea",
              `getLeiteCepeaByUf?uf=${encodeURIComponent(value)}`
            )
              .then((res) => {
                setCotacoesData(res);
              })
              .finally(() => {
                setIsLoading(false);
              });
          }}
          allowClear={true}
        />
      ),
      span: 3,
    },
    {
      label: "Última Alteração",
      children: formatDateHourToBR(cotacoesData.lei_data),
      span: 3,
    },
  ];

  return (
    <>
      <DescriptionsLayout
        title={"Interleite Cepea - Cotações"}
        items={[...items, ...aux.filter(Boolean)]}
        extra={
          <div style={{ padding: 10, display: "flex", gap: 10 }}>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              icon={<FaSave />}
              disabled={isLoading}
              onClick={async () => {
                saveData({
                  ...cotacoesData,
                  insert: "insertLeiteCepea",
                  path: "leite_cepea",
                });
              }}
            >
              Inserir
            </Button>
          </div>
        }
      />
    </>
  );
}